import config from "../config/env";
import React from "react";
import CareScreener from "../components/care-screener/CareScreener";

const TYPEFORM_ID = config.env.REACT_APP_LYRA_TYPE_FORM_ID;
const TYPEFORM_PATH = "lyra";

export default function Lyra() {
  return <CareScreener typeformId={TYPEFORM_ID} typeformPath={TYPEFORM_PATH} allowAppointmentScheduling={false} />;
}
